"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const boldTextStyle = {
    root: { fontWeight: office_ui_fabric_react_1.FontWeights.semibold }
};
const PageContent = ({ title, children }) => react_1.default.createElement(office_ui_fabric_react_1.Stack, { horizontalAlign: "start", verticalAlign: "center", styles: { root: { alignSelf: 'start' } } },
    react_1.default.createElement(office_ui_fabric_react_1.Stack, { style: { maxWidth: '1600px', margin: '30px auto 0 auto', width: '100%', padding: '0 20px' }, tokens: {
            childrenGap: 10
        } },
        title &&
            react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "xxLarge", styles: boldTextStyle }, title),
        children));
exports.default = PageContent;
